/**
 * @generated SignedSource<<f66b273f2659b706b3eaa9b2203670b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type courseLessonUncompleteLessonMutation$variables = {
  id: string;
  username: string;
};
export type courseLessonUncompleteLessonMutation$data = {
  readonly uncompleteCourseClass: {
    readonly completed: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"cursos_lesson">;
  };
};
export type courseLessonUncompleteLessonMutation = {
  response: courseLessonUncompleteLessonMutation$data;
  variables: courseLessonUncompleteLessonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "username"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "class",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completed",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isCourseClass"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canAccess",
  "storageKey": null
},
v8 = [
  (v5/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "CourseSection",
  "kind": "LinkedField",
  "name": "section",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v11 = [
  {
    "kind": "Literal",
    "name": "status",
    "value": "ACTIVE"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedUrl",
  "storageKey": null
},
v15 = [
  (v14/*: any*/),
  (v5/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "playback",
  "storageKey": null
},
v17 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "NEWEST"
  }
],
v18 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isCommentInterface"
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarFallback",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageFile",
      "kind": "LinkedField",
      "name": "photo",
      "plural": false,
      "selections": (v15/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votes",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "CommentVote",
  "kind": "LinkedField",
  "name": "userVote",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vote",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "childrenCount",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v26 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "OLDEST"
  }
],
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v30 = [
  "orderBy"
],
v31 = [
  {
    "kind": "Literal",
    "name": "enabled",
    "value": "ACTIVE"
  }
],
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "courseLessonUncompleteLessonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "uncompleteCourseClass",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "username",
                "variableName": "username"
              }
            ],
            "kind": "FragmentSpread",
            "name": "cursos_lesson"
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "courseLessonUncompleteLessonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "uncompleteCourseClass",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "previousClass",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Course",
            "kind": "LinkedField",
            "name": "course",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "progress",
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "classAccessControl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "user",
                    "variableName": "username"
                  }
                ],
                "concreteType": "CourseMember",
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enrolledAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CourseMemberGroupMember",
                    "kind": "LinkedField",
                    "name": "memberGroup",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CourseMemberGroup",
                        "kind": "LinkedField",
                        "name": "group",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SectionReleaseTimeline",
                            "kind": "LinkedField",
                            "name": "releaseTimeline",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "daysToRelease",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "notAvailableBefore",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "CourseSection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": (v11/*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "classes",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v10/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Course",
                        "kind": "LinkedField",
                        "name": "course",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "classes(status:\"ACTIVE\")"
                  }
                ],
                "storageKey": "sections(status:\"ACTIVE\")"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Course",
                "kind": "LinkedField",
                "name": "course",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "video",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v13/*: any*/)
                    ],
                    "type": "ExternalVideo",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rawID",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "muxId",
                        "storageKey": null
                      },
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageFile",
                        "kind": "LinkedField",
                        "name": "thumbnail",
                        "plural": false,
                        "selections": (v15/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VideoPlayback",
                        "kind": "LinkedField",
                        "name": "playback",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "VideoFileTokens",
                            "kind": "LinkedField",
                            "name": "tokens",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "storyboard",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "thumbnail",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "VideoFile",
                    "abstractKey": null
                  },
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "nextClass",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v13/*: any*/),
                  (v10/*: any*/),
                  (v7/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "previousClass",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v10/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Attachment",
                "kind": "LinkedField",
                "name": "attachments",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "size",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "originalName",
                    "storageKey": null
                  },
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "commentCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v17/*: any*/),
                        "concreteType": "CommentInterfaceConnection",
                        "kind": "LinkedField",
                        "name": "comments",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentInterfaceEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v26/*: any*/),
                                    "concreteType": "CommentInterfaceConnection",
                                    "kind": "LinkedField",
                                    "name": "comments",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CommentInterfaceEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v3/*: any*/),
                                              (v18/*: any*/),
                                              (v5/*: any*/),
                                              (v19/*: any*/),
                                              (v20/*: any*/),
                                              (v21/*: any*/),
                                              (v22/*: any*/),
                                              (v23/*: any*/),
                                              (v24/*: any*/),
                                              (v25/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v27/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                          (v28/*: any*/),
                                          (v29/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "comments(first:3,orderBy:\"OLDEST\")"
                                  },
                                  {
                                    "alias": null,
                                    "args": (v26/*: any*/),
                                    "filters": (v30/*: any*/),
                                    "handle": "connection",
                                    "key": "childrenComments__comments",
                                    "kind": "LinkedHandle",
                                    "name": "comments"
                                  }
                                ],
                                "storageKey": null
                              },
                              (v27/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              (v29/*: any*/),
                              (v28/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "comments(first:10,orderBy:\"NEWEST\")"
                      },
                      {
                        "alias": null,
                        "args": (v17/*: any*/),
                        "filters": (v30/*: any*/),
                        "handle": "connection",
                        "key": "lessonComments_comments",
                        "kind": "LinkedHandle",
                        "name": "comments"
                      }
                    ],
                    "type": "CourseContent",
                    "abstractKey": null
                  }
                ],
                "type": "CourseClass",
                "abstractKey": "__isCourseClass"
              }
            ],
            "type": "CourseContent",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v10/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Quiz",
                "kind": "LinkedField",
                "name": "quiz",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": (v31/*: any*/),
                    "concreteType": "QuizQuestion",
                    "kind": "LinkedField",
                    "name": "questions",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      (v32/*: any*/),
                      {
                        "alias": null,
                        "args": (v31/*: any*/),
                        "concreteType": "QuizQuestionOption",
                        "kind": "LinkedField",
                        "name": "options",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          (v32/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "text",
                            "storageKey": null
                          }
                        ],
                        "storageKey": "options(enabled:\"ACTIVE\")"
                      }
                    ],
                    "storageKey": "questions(enabled:\"ACTIVE\")"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "nextClass",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v7/*: any*/),
                  (v10/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "previousClass",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "CourseQuiz",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2530199b56df2c0b561051bc48ee40cb",
    "id": null,
    "metadata": {},
    "name": "courseLessonUncompleteLessonMutation",
    "operationKind": "mutation",
    "text": "mutation courseLessonUncompleteLessonMutation(\n  $id: ID!\n  $username: String!\n) {\n  uncompleteCourseClass(class: $id) {\n    __typename\n    ...cursos_lesson_42ijek\n    completed\n    id\n  }\n}\n\nfragment certificateEmitDialogFragment on Course {\n  id\n  name\n}\n\nfragment commentFragment on CommentInterface {\n  __isCommentInterface: __typename\n  id\n  content\n  author {\n    id\n    avatarFallback\n    displayName\n    photo {\n      signedUrl\n      id\n    }\n    username\n  }\n  parent {\n    __typename\n    id\n  }\n  votes\n  userVote {\n    vote\n  }\n  childrenCount\n  createdAt\n  __typename\n}\n\nfragment commentListFragment on CommentInterfaceConnection {\n  edges {\n    node {\n      id\n      ...comment_parentComment\n      __typename\n    }\n    cursor\n  }\n}\n\nfragment comment_childrenComments on CommentInterface {\n  __isCommentInterface: __typename\n  comments(first: 3, orderBy: OLDEST) {\n    edges {\n      node {\n        __typename\n        ...commentFragment\n        id\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment comment_parentComment on CommentInterface {\n  __isCommentInterface: __typename\n  ...commentFragment\n  ...comment_childrenComments\n  childrenCount\n}\n\nfragment courseLessonComments_lesson on CourseClass {\n  __isCourseClass: __typename\n  id\n  ... on CourseContent {\n    commentCount\n    comments(first: 10, orderBy: NEWEST) {\n      ...commentListFragment\n      edges {\n        node {\n          __typename\n          id\n        }\n        cursor\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n}\n\nfragment courseLesson_lesson on CourseContent {\n  id\n  name\n  description\n  completed\n  section {\n    id\n  }\n  course {\n    slug\n    progress\n    completed\n    ...certificateEmitDialogFragment\n    id\n  }\n  ...courseVideo\n  video {\n    __typename\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  nextClass {\n    __typename\n    url\n    slug\n    canAccess\n    id\n  }\n  previousClass {\n    __typename\n    url\n    slug\n    canAccess\n    id\n  }\n  attachments {\n    id\n    size\n    originalName\n    signedUrl\n  }\n  ...courseLessonComments_lesson\n}\n\nfragment courseQuiz_quiz on CourseQuiz {\n  id\n  name\n  slug\n  description\n  completed\n  quiz {\n    id\n    questions(enabled: ACTIVE) {\n      id\n      title\n      description\n      active\n      options(enabled: ACTIVE) {\n        id\n        active\n        text\n      }\n    }\n  }\n  course {\n    slug\n    ...certificateEmitDialogFragment\n    id\n  }\n  nextClass {\n    __typename\n    canAccess\n    slug\n    id\n  }\n  previousClass {\n    __typename\n    canAccess\n    slug\n    id\n  }\n}\n\nfragment courseSectionsPreview on Course {\n  id\n  sections(status: ACTIVE) {\n    id\n    ...courseSectionsPreview_section\n  }\n}\n\nfragment courseSectionsPreview_lesson on CourseClass {\n  __isCourseClass: __typename\n  id\n  slug\n  name\n  canAccess\n  completed\n  course {\n    slug\n    id\n  }\n}\n\nfragment courseSectionsPreview_section on CourseSection {\n  id\n  name\n  classes(status: ACTIVE) {\n    __typename\n    id\n    name\n    completed\n    ...courseSectionsPreview_lesson\n  }\n}\n\nfragment courseVideo on CourseContent {\n  video {\n    ... on ExternalVideo {\n      url\n    }\n    ... on VideoFile {\n      id\n      rawID\n      muxId\n      url\n      status\n      thumbnail {\n        signedUrl\n        id\n      }\n      playback {\n        playback\n        tokens {\n          playback\n          storyboard\n          thumbnail\n        }\n      }\n      ...courseVideo_video\n    }\n    __typename\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment courseVideo_video on VideoFile {\n  id\n  rawID\n  muxId\n  url\n  status\n  playback {\n    playback\n    tokens {\n      playback\n      storyboard\n      thumbnail\n    }\n  }\n}\n\nfragment cursos_lesson_42ijek on CourseClass {\n  __isCourseClass: __typename\n  id\n  name\n  canAccess\n  section {\n    id\n  }\n  previousClass {\n    __typename\n    completed\n    id\n  }\n  course {\n    name\n    progress\n    slug\n    classAccessControl\n    member(user: $username) {\n      id\n      enrolledAt\n      memberGroup {\n        group {\n          releaseTimeline {\n            section {\n              id\n            }\n            daysToRelease\n            notAvailableBefore\n          }\n          id\n        }\n        id\n      }\n    }\n    ...courseSectionsPreview\n    id\n  }\n  ... on CourseContent {\n    ...courseLesson_lesson\n  }\n  ... on CourseQuiz {\n    ...courseQuiz_quiz\n  }\n  ...lessonBlocked_lesson\n  __typename\n}\n\nfragment lessonBlocked_lesson on CourseClass {\n  __isCourseClass: __typename\n  name\n}\n"
  }
};
})();

(node as any).hash = "d7f207e1a6e5e2e3fc50efb636016d98";

export default node;
